import styled from '@emotion/styled';
import { CSSProperties, ReactElement } from 'react';

import { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';
import { Interface } from '../interface';

export const Base = ({
	color,
	height,
	width,
	backgroundColor,
}: {
	color: CSSProperties['color'];
	height: CSSProperties['height'];
	width: CSSProperties['width'];
	backgroundColor: CSSProperties['backgroundColor'];
}): ReactElement => (
	<svg width={width} height={height} viewBox="0 0 25 25" fill={backgroundColor} xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12 0a4.692 4.692 0 00-4.686 4.686v7.964A4.692 4.692 0 0012 17.336c2.584 0 4.686-2.114 4.686-4.713V4.686A4.691 4.691 0 0012 0zm3.06 12.623c0 1.703-1.372 3.088-3.06 3.088a3.064 3.064 0 01-3.061-3.06V4.685A3.064 3.064 0 0112 1.626a3.064 3.064 0 013.06 3.06v7.937zM12.813 19.693h-1.626v3.684h1.626v-3.684z"
			fill={color}
		/>
		<path
			d="M15.359 22.375H8.64a.813.813 0 100 1.625h6.718a.813.813 0 100-1.625zM18.853 8.641a.813.813 0 00-.812.813v3.196c0 3.33-2.71 6.04-6.04 6.04a6.047 6.047 0 01-6.042-6.04V9.454a.813.813 0 10-1.625 0v3.196c0 4.227 3.44 7.666 7.666 7.666 4.227 0 7.666-3.439 7.666-7.666V9.454a.813.813 0 00-.813-.813z"
			fill={color}
		/>
		<path
			d="M21.893 2.107a.812.812 0 00-1.15 0L2.108 20.744a.812.812 0 101.15 1.149L21.892 3.256a.812.812 0 000-1.149z"
			fill={color}
		/>
	</svg>
);

export const SlashedAudioIcon = styled((props: Interface) => {
	const theme = useTheme();
	return (
		<div {...props}>
			<Base
				width={theme.videoCalls.icons.microphoneSlashedIcon.width}
				height={theme.videoCalls.icons.microphoneSlashedIcon.height}
				backgroundColor={theme.videoCalls.icons.microphoneSlashedIcon.backgroundColor}
				color={theme.videoCalls.icons.microphoneSlashedIcon.fill}
			/>
		</div>
	);
})(({ theme }: { theme?: Theme }) => theme?.videoCalls.icons.microphoneSlashedIcon);
